import React, { Component } from 'react';
import Form from 'react-bootstrap/Form';
import 'toastr/build/toastr.min.css';
import { DisplayMessage } from '../../../services/helpers.js';
import DelayedRedirect from '../../../utils/DelayedRedirect';
import { Transition } from '../../../utils/ModalHelpers';
import { Button } from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';
import Paper from '@material-ui/core/Paper';
import Dialog from '@material-ui/core/Dialog';
import AppBar from '@material-ui/core/AppBar';
import TextField from '@material-ui/core/TextField';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import { SelectTheme } from '../../../utils/utils.js';
import { ThemeProvider } from "@material-ui/core";
import appFetch from '../../../api/appFetch.js';
import { InternalChatGroupsUrl } from '../../../constants/apiUrls.js';
import OutletsDropdown from '../../Common/Dropdowns/OutletsDropdown.js';
import { ChatGroupUsages } from '../../../constants/chatGroupUsages.js';


export default class ChatGroupsCreation extends Component {
    constructor(props) {
        super(props);
        this.state = {
            id: 0,
            outletId: props.selectedOutletId,
            description: "",
            internalChatName: "",
            isActive: false,
            usageChat: false,
            usageTasks: false,
            selectedOutletId: 0,
            loading: this.props.editedChatGroupId !== undefined,
            redirect: false,
            accessibleMoboOutlets: [],
            editedChatGroupId: this.props.editedChatGroupId,
            requestInProgress: false,
            open: true,
            ChatGroupWasCreated: false,
        };
    }

    componentDidMount() {
        var outlets = this.props.accessibleMoboOutlets.sort((a, b) => (a.description > b.description) ? 1 : -1)
        if (this.props.accessibleMoboOutlets === undefined) {
            return;
        }

        var outlet = outlets[0].id;

        if (this.props.outletId !== undefined) {
            this.setState({ outletId: this.props.outletId });
        }
        else {
            this.setState({ outletId: outlet });
        }
    }

    isFormValid = () => {
        const { description, internalChatName, usageChat, usageTasks } = this.state;

        if (!description || description.trim().length === 0) {
            return false;
        }

        if (!internalChatName || internalChatName.trim().length === 0) {
            return false;
        }

        if (!usageChat && !usageTasks) {
            return false;
        }

        return true;
    }

    handleClose = () => {
        this.setState({ open: false, redirect: "/chatgroups" });
    };

    handleChange = (e) => {
        if (e.target.name === "internalChatName") {
            this.setState({ [e.target.name]: e.target.value.replace(/ /g, '') });
            return;
        }

        this.setState({ [e.target.name]: e.target.value.replace(/^\s+/, "") });
    };

    handleChangeCheckBox = e => {
        this.setState({ [e.target.name]: e.target.checked });
    };


    handleChangeOutlet = e => {
        this.setState({ outletId: e.target.value });
    };


    handleSaveChatGroup = () => {
        this.saveNewChatGroup();
    }

    saveNewChatGroup = () => {
        this.setState({ requestInProgress: true });

        let resources = this.props.resources;
        if (this.state.description.trim().length <= 0) {
            DisplayMessage(resources["InvalidDescripton"], "error");
            return;
        }

        if (this.state.internalChatName.trim().length <= 0) {
            DisplayMessage(resources["InvalidChatName"], "error");
            return;
        }

        var usages = [];
        if (this.state.usageChat) usages.push(ChatGroupUsages.Chat);
        if (this.state.usageTasks) usages.push(ChatGroupUsages.Tasks);

        var json = JSON.stringify({
            moboOutletId: this.state.outletId ? this.state.outletId : null,
            description: this.state.description !== "" ? this.state.description : null,
            internalChatName: this.state.internalChatName !== "" ? this.state.internalChatName : null,
            isActive: this.state.isActive,
            usages: usages,
        });

        const url = InternalChatGroupsUrl();

        appFetch({
            url: url,
            method: 'POST',
            body: json,
            onSuccess: () => {
                DisplayMessage(resources["NewChatGroupWasSaved"], "success");
                this.setState({ ChatGroupWasCreated: true, redirect: "/chatgroups" });
            },
            onError: (response) => {
                for (let i = 0; i < response.errors.length; i++) {
                    DisplayMessage(response.errors[i], "error");
                }
            },
            onFinalize: () => {
                this.setState({ requestInProgress: false });
            }
        })
    }

    handleSubmit = (event) => {
        event.preventDefault();
        event.stopPropagation();
        this.handleSaveChatGroup();
    };

    renderForm() {
        const { isActive, description, internalChatName } = this.state;

        var resources = this.props.resources;
        var helperTextDescription = description.trim().length <= 0 ? "helper-text-red" : "helper-text-grey";
        var helperTextChatName = internalChatName === "" ? "helper-text-red" : "helper-text-grey";

        return (
            <Paper elevation={3} className="p-4 mt-3 mb-3">
                <Form onSubmit={this.handleSubmit} >
                    <Form.Group className="pt-3 d-flex"  >
                        <div className="col-3"></div>
                        <ThemeProvider theme={SelectTheme}>
                            <TextField className={"col-6 " + helperTextDescription} id="chatgroup-description" value={description} label={resources["Description"]}
                                helperText={resources["InputOfDescriptionIsMandatory"]}
                                variant="outlined" name="description" onChange={this.handleChange} inputProps={{ maxLength: 100 }} />
                        </ThemeProvider >
                    </Form.Group>

                    <Form.Group className="d-flex"  >
                        <div className="col-3"></div>
                        <ThemeProvider theme={SelectTheme}>
                            <TextField className={"col-6 " + helperTextChatName} id="chatgroup-chatname" value={internalChatName} label={resources["ChatName"]}
                                helperText={resources["InputOfChatNameIsMandatory"]}
                                variant="outlined" name="internalChatName" onChange={this.handleChange} inputProps={{ maxLength: 20 }} />
                        </ThemeProvider >
                    </Form.Group>
                    <Form.Group className="d-flex" >
                        <div className="col-3"></div>
                        <OutletsDropdown
                            resources={resources}
                            outlets={this.props.accessibleMoboOutlets}
                            outlet={this.state.outletId}
                            onOutletChange={this.handleChangeOutlet}
                            containerClass="col-6 helper-text-red"
                        />
                    </Form.Group>
                    <Form.Group style={{ display: "flex" }}>
                        <div className="col-md-3"></div>
                        <div className="col-md-6 p-0">
                            <div className="mb-1">
                                <strong style={{ fontSize: "14px" }}>{resources["LabelUsage"]}</strong><span style={{ color: "#f44336", marginLeft: "2px" }}>*</span>
                                <span style={{ fontSize: "14px", fontWeight: "normal", color: "rgba(0,0,0,0.54)" }}>
                                    {" "}({resources["LabelUsageSelectAtLeastOne"]})
                                </span>
                            </div>
                            <FormControlLabel className="d-block m-0"
                                control={<Checkbox id="chatgroup-usage-chat" checked={this.state.usageChat} onChange={this.handleChangeCheckBox} name="usageChat" color="primary" />}
                                label={resources["LabelUsageChat"]} />
                            <FormControlLabel className="d-block m-0"
                                control={<Checkbox id="chatgroup-usage-tasks" checked={this.state.usageTasks} onChange={this.handleChangeCheckBox} name="usageTasks" color="primary" />}
                                label={resources["LabelUsageTasks"]} />
                        </div>
                    </Form.Group>
                    <Form.Group style={{ display: "flex" }} >
                        <div className="col-md-3 "> </div>
                        <FormControlLabel className="col-md-6 text-right label-mt my-auto p-0"
                            control={<Checkbox id="chatgroup-is-active" checked={isActive} onChange={this.handleChangeCheckBox} name="isActive" color="primary" />}
                            label={resources["IsActive"]} />
                        <div className="col-md-4"> </div>
                    </Form.Group>
                </Form>
            </Paper>
        );
    }

    renderMain() {
        const { loading } = this.state;

        if (loading) {
            return (<div className="centered-loader"><CircularProgress /></div>);
        }

        return <div className={"py-4 grey " + (this.state.loading ? 'fadeOut' : 'fadeIn')}>
            {this.renderForm()}
        </div>;
    }

    render() {
        const { redirect, open, ChatGroupWasCreated, outletId, requestInProgress } = this.state;
        const { resources } = this.props;

        const isSaveButtonDisabled = requestInProgress || !this.isFormValid() || redirect;

        return (
            <div>
                {redirect && <DelayedRedirect to={{ pathname: redirect, state: { refreshGrid: ChatGroupWasCreated, outletId } }} delay={250} />}
                <Dialog fullScreen open={open} onClose={this.handleClose} TransitionComponent={Transition}>
                    <AppBar className="position-sticky">
                        <Toolbar>
                            <IconButton id="close-add-chatgroup" edge="start" color="inherit" onClick={this.handleClose} aria-label="close">
                                <CloseIcon />
                            </IconButton>
                            <Typography variant="h6" style={{ flex: 1 }}>
                                {resources["AddNewChatGroupTitle"]}
                            </Typography>
                            <Button id="chatgroup-save" color="inherit" disabled={isSaveButtonDisabled} onClick={this.handleSubmit}>{resources["Save"]}</Button>
                        </Toolbar>
                    </AppBar>
                    <div className="container">
                        {this.renderMain()}
                    </div>
                </Dialog>
            </div >
        );
    }
}